import { User } from '../common/Interface/User';

/**
 * ユーザーリストをソートする共通関数
 * 
 * ソート優先順位:
 * 1. 正社員であること (isPermanentEmployee: true が優先)
 * 2. 監視対象であること (monitoringTarget: true が優先)  
 * 3. 名前の昇順 (lastName + firstName)
 *
 * @param users ソート対象のユーザー配列
 * @returns ソート済みのユーザー配列
 */
export const sortUsersByPriority = (users: User[]): User[] => {
  return [...users].sort((a, b) => {
    // 1. 正社員かどうかで比較 (正社員が優先)
    if (a.isPermanentEmployee !== b.isPermanentEmployee) {
      return b.isPermanentEmployee ? 1 : -1;
    }

    // 2. 監視対象かどうかで比較 (監視対象が優先)
    if (a.monitoringTarget !== b.monitoringTarget) {
      return b.monitoringTarget ? 1 : -1;
    }

    // 3. 名前の昇順で比較
    const nameA = `${a.lastName} ${a.firstName || ''}`.trim();
    const nameB = `${b.lastName} ${b.firstName || ''}`.trim();
    
    return nameA.localeCompare(nameB, 'ja', { 
      numeric: true,
      sensitivity: 'base'
    });
  });
};